<template>
  <div>
    <ModalPreviewCampanhaTable
      :tableHeaders="tableHeaders"
      :tableContent="tableContent"
      v-if="tableContent"
      @reexecutar="reexecutarPrevia()"
    />
    <div class="d-flex w-100 justify-content-end align-items-center">
      <transition name="fade">
        <div
          class="total-de-mensagens-container mr-3"
          v-if="campanhaExecutada && totalDeMensagens !== null"
        >
          <span class="mr-1">Total de mensagens da campanha:</span>
          <strong>{{ totalDeMensagens }}</strong>
        </div>
      </transition>
      <transition name="fade-slower">
        <div
          class="btn botao-filtro-ver-preview mr-5 text-uppercase"
          @click="solicitarPrevia()"
          v-if="btnMostrarModalVisible || isBankAPI"
          ref="btnExecutarPreviewCompleto"
        >
          Solicitar Prévia Completa
        </div>
      </transition>
      <div
        class="btn botao-filtro-preview text-uppercase mr-3"
        variant="primary"
        @click="solicitarPreviaApenasCount()"
        v-if="listaDeFiltros.length > 0 && !isBankAPI"
        ref="btnExecutarPreviewModalCadastroCampanha"
      >
        Solicitar Prévia
      </div>
      <button
        class="btn botao-filtro-add text-uppercase"
        @click="adicionarNovoFiltro"
      >
        + Adicionar novo filtro
      </button>
    </div>
    <hr />
    <nested-draggable
      :group="0"
      :listaDeFiltros="listaDeFiltros"
      :camposPossiveisDoFiltro="camposPossiveisDoFiltro"
      :opreadoresFiltro="opreadoresFiltro"
      class="col mt-5"
      :isDraggable="isDraggable"
      :sistemaLicenciadaId="sistemaLicenciadaId"
    >
    </nested-draggable>
  </div>
</template>
<script>
import Utils from "@/core/utils/Utils";
import nestedDraggable from "@/view/pages/painel/automacao/campanha/cadastro-componentes/NestedDraggable.vue";
import campanhaService from "@/core/services/campanha.service";
import ModalPreviewCampanhaTable from "@/view/pages/painel/automacao/campanha/components/ModalPreviewCampanhaTable.vue";

export default {
  name: "FiltrosModeloCampanha",
  props: {
    listaDeFiltros: {
      required: true,
      type: Array
    },
    group: {
      required: true,
      type: Number
    },
    camposPossiveisDoFiltro: {
      required: true,
      type: Array
    },
    opreadoresFiltro: {
      required: true,
      type: Array
    },
    isDraggable: {
      required: true,
      type: Boolean
    },
    sistemaLicenciadaId: {
      required: false
    },
    modeloId: {
      required: false
    },
    contextFunctions: {
      required: false
    },
    liscencedDatabases: {
      required: false
    },
    modeloFiltrosObrigatorios: {
      required: false
    }
  },
  components: {
    nestedDraggable,
    ModalPreviewCampanhaTable
  },
  data() {
    return {
      executouPreviewCompleto: false,
      campanhaExecutada: false,
      tableHeaders: null,
      tableContent: null,
      current_uid_preview: null,
      btnMostrarModalVisible: false,
      totalDeMensagens: null
    };
  },
  methods: {
    adicionarNovoFiltro() {
      this.listaDeFiltros.push({
        hierarquia: 0,
        filtro_id: 1,
        mfi_valor: "",
        ope_titulo: "",
        mfi_e_ou: "AND",
        mfi_valor_2: null, //(apenas se for um between),
        operador_id: 12, //(cada condição vai ter um id),
        listaDeFiltros: [],
        contexto_id: null
      });
      // this.listaDeFiltros = Utils.addNovoFiltro(
      //   JSON.parse(JSON.stringify(this.listaDeFiltros)),
      //   this.modeloFiltrosObrigatorios
      // );
      this.listaDeFiltros.forEach((v, i) => {
        if (!(Array.isArray(v.listaDeFiltros) && v.listaDeFiltros.length)) {
          if (!v.mfi_e_ou) v.mfi_e_ou = "AND";
        }
        delete this.listaDeFiltros[this.listaDeFiltros.length - 1].mfi_e_ou;
      });
    },
    /**
     * Refaz a busca da previa apos a troca do estado de protecao (WEL-5344).
     *
     * Nao chama `solicitarPrevia`: aquele metodo tem um curto-circuito no topo
     * que, depois da primeira previa completa, apenas reabre o modal e retorna.
     * Era por isso que o botao parecia nao funcionar e so adiantava fechar o
     * modal e pedir a previa de novo.
     *
     * Reaproveita o `uid` ja obtido, entao nao ha nova consulta ao ERP do
     * cliente: e o mesmo resultado, buscado outra vez, e o servidor o devolve
     * ja no estado novo.
     */
    async reexecutarPrevia() {
      if (this.current_uid_preview) {
        await this.buscarDadosPrevia(this.current_uid_preview);
        return;
      }

      await this.solicitarPrevia();
    },

    async solicitarPrevia() {
      try {
        if (this.executouPreviewCompleto) {
          this.mostrarModalPreviewTable();
          return;
        }

        this.campanhaExecutada = true;
        this.tableHeaders = null;
        this.tableContent = null;

        if (this.current_uid_preview) {
          await this.buscarDadosPrevia(this.current_uid_preview);
          return;
        }

        const res = await campanhaService.solicitarPreviaCampanha({
          campanha: {
            sistema_licenciada_id: this.sistemaLicenciadaId,
            modelo_id: this.modeloId,
            filtros: this.listaDeFiltros
          }
        });
        // mdc_variaveis_filtro_nativo:
        //   this.full_object_payload.mdc_variaveis_filtro_nativo,

        if (res.data.requisicao.sucesso) {
          this.current_uid_preview = res.data.requisicao.uid;
          await this.buscarDadosPrevia(this.current_uid_preview);
        } else {
          this.exibirToast("error", "Erro", "Cliente offline.", 3000);
        }
      } catch (error) {
        console.error("Erro ao solicitar prévia:", error);
        this.exibirToast(
          "error",
          "Erro inesperado",
          "Ocorreu um erro ao processar a solicitação.",
          5000
        );
      }
    },
    solicitarPreviaApenasCount() {
      this.campanhaExecutada = true;
      this.totalDeMensagens = null;
      this.tableHeaders = null;
      this.tableContent = null;
      this.btnMostrarModalVisible = false;

      if (this.current_uid_preview_count) {
        campanhaService
          .buscarDadosPrevia({
            sistemaLicenciadaId: this.sistemaLicenciadaId,
            uid: this.current_uid_preview_count
          })
          .then((res2) => {
            if (res2.data.requisicao.sucesso) {
              if (
                res2.data.requisicao.requisicao?.resultado?.code === "EREQUEST"
              ) {
                const response_error_stringified = JSON.stringify(
                  res2.data.requisicao.requisicao?.resultado
                );
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: response_error_stringified,
                  life: 7000
                });
                this.current_uid_preview_count = null;
                return;
              }

              if (res2.data.requisicao.requisicao.status == "PENDENTE") {
                this.$refs.btnExecutarPreviewModalCadastroCampanha.innerText =
                  "Tentar Novamente";
                this.$toast.add({
                  severity: "warn",
                  summary: "Resultado Pendente",
                  detail: `O resultado da prévia ainda está sendo processando. Tente novamente.`,
                  life: 7000
                });
                return;
              }

              this.totalDeMensagens =
                res2.data.requisicao.requisicao.resultado[0]?.count_qtd;
              this.tableHeaders = Object.keys(
                res2.data.requisicao.requisicao.resultado[0]
              );
              this.tableContent = res2.data.requisicao.requisicao.resultado;
              this.btnMostrarModalVisible = true;
              this.previewJaFoiExecutado = true;
              this.$refs.btnExecutarPreviewModalExecucaoManual.innerText =
                "Solicitar Prévia";
              this.executouPreviewCompleto = false;
              this.current_uid_preview_count = null;
            }
          });
        return;
      }

      // mdc_variaveis_filtro_nativo:
      //   this.full_object_payload.mdc_variaveis_filtro_nativo,
      campanhaService
        .solicitarPreviaCampanha({
          apenas_count: true,
          campanha: {
            sistema_licenciada_id: this.sistemaLicenciadaId,
            modelo_id: this.modeloId,
            filtros: this.listaDeFiltros
          }
        })
        .then((res) => {
          if (res.data.requisicao.sucesso) {
            this.current_uid_preview_count = res.data.requisicao.uid;
            campanhaService
              .buscarDadosPrevia({
                sistemaLicenciadaId: this.sistemaLicenciadaId,
                uid: res.data.requisicao.uid
              })
              .then((res2) => {
                if (res2.data.requisicao.sucesso) {
                  this.current_uid_preview_count = res2.data.requisicao.uid;
                  if (
                    res2.data.requisicao.requisicao?.resultado?.code ===
                    "EREQUEST"
                  ) {
                    const { message = "Campanha Invalida." } =
                      res2.data.requisicao.requisicao?.resultado;
                    this.$toast.add({
                      severity: "error",
                      summary: "Erro",
                      detail: message,
                      life: 7000
                    });
                    this.current_uid_preview_count = null;
                    return;
                  }
                  if (res2.data.requisicao.requisicao.status == "PENDENTE") {
                    this.$refs.btnExecutarPreviewModalCadastroCampanha.innerText =
                      "Tentar Novamente";
                    this.$toast.add({
                      severity: "warn",
                      summary: "Resultado Pendente",
                      detail: `O resultado da prévia ainda está sendo processando. Tente novamente.`,
                      life: 7000
                    });
                    return;
                  }

                  this.totalDeMensagens =
                    res2.data.requisicao.requisicao.resultado[0]?.count_qtd;
                  this.tableHeaders = Object.keys(
                    res2.data.requisicao.requisicao.resultado[0]
                  );
                  this.tableContent = res2.data.requisicao.requisicao.resultado;
                  this.btnMostrarModalVisible = true;
                  this.previewJaFoiExecutado = true;
                  this.$refs.btnExecutarPreviewModalCadastroCampanha.innerText =
                    "Solicitar Prévia";
                  this.executouPreviewCompleto = false;
                  this.current_uid_preview_count = null;
                }
              });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: `Cliente offline.`,
              life: 3000
            });
          }
        });
    },
    async buscarDadosPrevia(uid) {
      try {
        // const res2 = await ApiService.get(
        //   `${API_LINKS.campanhaPreviewDados}/${this.full_object_payload.sistema_licenciada_id}/${uid}`
        // );

        const res2 = await campanhaService.buscarDadosPrevia({
          sistemaLicenciadaId: this.sistemaLicenciadaId,
          uid
        });

        if (!res2.data.requisicao.sucesso) {
          this.exibirToast(
            "error",
            "Erro",
            "Falha ao obter dados da prévia.",
            5000
          );
          return;
        }

        const requisicao = res2.data.requisicao.requisicao || {};

        if (requisicao.resultado?.code === "EREQUEST") {
          this.exibirToast(
            "error",
            "Erro",
            JSON.stringify(requisicao.resultado),
            7000
          );
          this.current_uid_preview = null;
          return;
        }

        if (requisicao.status === "PENDENTE") {
          this.definirBotaoTexto("Tentar Novamente");
          this.exibirToast(
            "warn",
            "Resultado Pendente",
            "O resultado da prévia ainda está sendo processado. Tente novamente.",
            7000
          );
          return;
        }

        this.processarDadosPrevia(requisicao.resultado);
      } catch (error) {
        console.error("Erro ao buscar dados da prévia:", error);
        this.exibirToast(
          "error",
          "Erro inesperado",
          "Não foi possível buscar os dados da prévia.",
          5000
        );
      }
    },
    mostrarModalPreviewTable() {
      this.$modal.show("modal-preview-table");
    },
    exibirToast(severity, summary, detail, life = 5000) {
      this.$toast.add({ severity, summary, detail, life });
    },

    processarDadosPrevia(resultado) {
      this.totalDeMensagens = Array.isArray(resultado) ? resultado.length : 0;

      if (this.totalDeMensagens > 0) {
        this.tableHeaders = Object.keys(resultado[0]);
        this.tableContent = resultado;
        this.definirBotaoTexto("Solicitar Prévia");

        setTimeout(() => {
          this.mostrarModalPreviewTable();
          this.executouPreviewCompleto = true;
        }, 500);

        this.current_uid_preview = null;
      } else {
        this.exibirToast(
          "warn",
          "Resultado Vazio",
          "A prévia completa não retornou nenhum resultado.",
          7000
        );
        this.tableHeaders = null;
        this.tableContent = null;
        this.current_uid_preview = null;
      }
    },
    definirBotaoTexto(texto) {
      if (this.$refs.btnExecutarPreviewModalCadastroCampanha) {
        this.$refs.btnExecutarPreviewModalCadastroCampanha.innerText = texto;
      }
    }
  },
  computed: {
    isBankAPI() {
      const bank = this.liscencedDatabases.find((banco) => {
        return banco.sistema_licenciada_id == this.sistemaLicenciadaId;
      });
      if (bank) {
        return ["API_E", "API_G"].includes(bank.banco_id);
      }
      return false;
    }
  }
};
</script>
<style scoped>
.botao-filtro-add {
  border: 1px solid #1bc5bd;
  color: #1bc5bd;
  padding: 2px 6px;
  border-radius: 5px;
  z-index: 10;
  padding: 4px 12px;
  height: 38px;
}

.botao-filtro-preview {
  border: 1px solid #ffa800;
  color: #ffa800;
  border-radius: 5px;
  z-index: 10;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.botao-filtro-ver-preview {
  border: 1px solid #f64e60;
  color: #f64e60;
  border-radius: 5px;
  z-index: 10;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
